/**
 * Social intro javascript helper functions
 *
 * @author Brian Piejak (bpiejak@yext.com)
 */

goog.provide('yext.storm.socialintro');
goog.require('yext.plugins.selectify');

/**
 * Initializes location selectify
 *
 * @param localOptimization: boolean
 */
yext.storm.socialintro.initLocationSelectify = function(localOptimization) {
  $('.location-selectify').selectify({
    width: localOptimization ? '250px' : '200px',
    singleLineSelectValue: false,
  });
};

/**
 * Initializes account selectify
 *
 * @param numAccounts: number
 */
yext.storm.socialintro.initAccountSelectify = function(numAccounts) {
  $('.account-selectify').selectify({
    width: '195px',
    disabled: numAccounts === 1,
  });
};

/**
 * initializes radio select
 */
yext.storm.socialintro.initRadiofy = function() {
  $('.js-radio').radiofy({});
};

goog.exportSymbol(
  'yext.storm.socialintro.initLocationSelectify', yext.storm.socialintro.initLocationSelectify);
goog.exportSymbol(
  'yext.storm.socialintro.initAccountSelectify', yext.storm.socialintro.initAccountSelectify);
goog.exportSymbol('yext.storm.socialintro.initRadiofy', yext.storm.socialintro.initRadiofy);
